// @flow
import type { TestSchedule, Product as ProductType } from "../../lib/Types";
import React from "react";
import styled, { css } from "styled-components";
import { normalPost } from "../../lib/Fetching";
import Columns from "react-columns";
import Product from "./Product";
import { DefaultPaddedContainerNoShadow, DefaultContainer } from "./Theme";
import _ from "underscore";
import Link from "../Link";
import AddProducts from "./AddProducts";

const PickerContainer = styled.div`
  margin-top: 5px;
`;

type Props = {
  products: Array<ProductType>,
  onlyPickSchedule: ?boolean,
  pickSchedule: Function,
  registerProtocol: Function,
  companyId: number,
  reloadProducts: ?Function,
  authoriser: object,
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  margin: 0 auto;
  margin-right: -5px;
  ${(props) =>
    props &&
    props.maxCols &&
    `
    max-width: ${Math.max(props.maxCols * 700, 1900)}px;
  `};
`;

const Item = styled.div`
  flex-grow: 1;
  // max-width: 600px;
  min-width: 700px;
  margin-right: 5px;
  :last-child {
    margin-right: 0px;
  }
`;

const LetterHeading = styled(DefaultContainer)`
  font-weight: bold;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 0px;
  user-select: none;
  margin-bottom: 4px;
  color: #888888;
  .item-count {
    color: #ccc;
  }
`;

const NoProductsFoundContainer = styled(DefaultPaddedContainerNoShadow)`
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
`;

export default class SchedulePicker extends React.Component<Props> {
  componentDidMount() {
    window.addEventListener("resize", this.setColumnCount.bind(this));
    this.setColumnCount();
  }

  setColumnCount() {
    var cols = 1.0;
    if (window.innerWidth <= 1600) {
      cols = 1.0;
    } else if (window.innerWidth <= 2400) {
      cols = 2.0;
    } else {
      cols = 2.0;
    }
    this.setState({ cols });
  }

  editDefaultAttributes() {
    const { products, companyId } = this.props;
    normalPost(
      "/products/default_product_list_items/edit",
      {
        ids: products.map((p) => p.id),
        company_id: companyId,
      },
      true,
      "GET"
    );
  }

  render() {
    const {
      products,
      showClientSuite,
      onlyPickSchedule,
      pickSchedule,
      registerProtocol,
      companyId,
      reloadProducts,
      authoriser,
    } = this.props;
    const cols = this.state ? this.state.cols || 1 : 1;

    const canAddProducts = authoriser && authoriser.has_client_permission("add_product_names");
    const canAddSchedules =
      authoriser && authoriser.has_client_permission("add_product_schedules");

    const productCount = products.length;
    const productsPerCol = productCount / (cols || 1);

    const groupByFirstLetter = _.groupBy(products, (p) => p.name[0].toUpperCase());

    const columns = [];
    // var columnProducts = [{ letters: [], products: [] }]
    // columns.push(columnProducts);

    var columnProducts = null;

    var currentColumnProductCount = 0;
    Object.keys(groupByFirstLetter).map((letter, index) => {
      var letterProducts = groupByFirstLetter[letter];
      if (
        columnProducts === null ||
        currentColumnProductCount > productsPerCol ||
        currentColumnProductCount + letterProducts.size - productsPerCol > productsPerCol / 8.0
      ) {
        currentColumnProductCount = 0;
        columnProducts = { letters: [], productsArray: [] };
        columns.push(columnProducts);
      }
      columnProducts.letters.push(letter);
      columnProducts.productsArray.push(letterProducts);
      currentColumnProductCount += letterProducts.length;
    });

    return (
      <PickerContainer>
        {products.length == 0 && (
          <NoProductsFoundContainer>No products were found.</NoProductsFoundContainer>
        )}
        {canAddProducts && (
          <Container>
            <AddProducts companyId={companyId} onAdded={reloadProducts} />
          </Container>
        )}
        <Container maxCols={columns.length}>
          {columns.map(
            (col, i) =>
              col.productsArray.length > 0 ? (
                <Item key={i}>
                  <LetterHeading>
                    {col.letters.length > 1 ? (
                      <span>
                        {col.letters[0]} - {col.letters[col.letters.length - 1]}
                      </span>
                    ) : (
                      <span>{col.letters[0]}</span>
                    )}
                    <div className="pull-right item-count">
                      {col.productsArray.reduce(
                        (total, products) => total + products.length,
                        0
                      )}{" "}
                      Items
                    </div>
                  </LetterHeading>
                  {col.productsArray.map((products) =>
                    products.map((p) => (
                      <Product
                        key={p.id + "-" + col.productsArray.length}
                        companyId={companyId}
                        product={p}
                        onlyPick={onlyPickSchedule}
                        pickSchedule={pickSchedule}
                        initialExpanded={col.productsArray.length == 1}
                        reload={reloadProducts}
                        addSchedules={canAddSchedules}
                        registerProtocol={registerProtocol}
                      />
                    ))
                  )}
                </Item>
              ) : null
          )}
        </Container>
        {products.length !== 0 && (
          <Link onClick={() => this.editDefaultAttributes()} className="pull-right">
            Edit Default Product Attributes
          </Link>
        )}
      </PickerContainer>
    );
  }
}
